import {
  TableRow,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
} from "@windmill/react-ui";
import CancellationPolicyTable from "components/cancellationpolicy/CancellationPolicyTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import Somethingwentwrong from "pages/Somethingwentwrong";

import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import CancellationPolicyServices from "services/CancellationPolicyServices";
import CancellationPolicyDrawer from "components/drawer/CancellationPolicyDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import { notifyError } from "utils/toast";
import sidebar from "routes/sidebar";
import { Tabs, Tab } from "@mui/material";

const CancellationPolicy = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { isUpdate, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { loading, error } = useAsync(
    CancellationPolicyServices.getAllCancellationPolicy
  );
  const [tab, setTab] = useState(0);
  const [cancellationpolicyData, setCancellationPolicyData] = useState([]);
  const [status, setStatus] = useState(false);
  const { dataTable, serviceData, currentPage } = useFilter(
    cancellationpolicyData,
    itemsPerPage
  );
  useEffect(() => {
    if (dataTable.length !== 0) {
      setItemsPerPage(dataTable.length);
    }
  }, [dataTable]);

  useEffect(() => {
    const fetchCancellationPolicy = async () => {
      //   setLoading(true);
      try {
        let response;
        // Fetch data based on the selected tab
        if (tab === 0) {
          response = await CancellationPolicyServices.getAllCancellationPolicy(
            1
          );
        } else if (tab === 1) {
          response = await CancellationPolicyServices.getAllCancellationPolicy(
            2
          );
        } else if (tab === 2) {
          response = await CancellationPolicyServices.getAllCancellationPolicy(
            3
          );
        } else if (tab === 3) {
          response = await CancellationPolicyServices.getAllCancellationPolicy(
            4
          );
        }
        else if (tab === 4) {
          response = await CancellationPolicyServices.getAllCancellationPolicy(
            5
          );
        }

        // Check the response structure (optional)

        if (response?.status === true && response?.data) {
          const { id, policy } = response.data;

          const updatedData = [
            {
              id,
              policy,
            },
          ];

          setCancellationPolicyData(updatedData);
          setStatus(response?.status);
        } else {
          setStatus(response?.status);
          // notifyError("No cancellation policy data found.");
        }
      } catch (error) {
        console.error("Error fetching cancellation policy:", error);
        notifyError(
          "Failed to fetch cancellation policy. Please try again later."
        );
      }
    };
    fetchCancellationPolicy();
    setIsUpdate(false);
    // eslint-disable-next-line
  }, [tab, isUpdate]);

  const handleTabChange = (_event, newValue) => {
    setTab(newValue);
  };
  const isAdmin = adminInfo?.id === 1;

  const hideView = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "cancellation policy" && perm.view === 1
  );

  const hideEdit = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "cancellation policy" && perm.edit === 1
  );

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />
          <MainDrawer>
            <CancellationPolicyDrawer id={serviceId} />
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Outstation"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Hour rental"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Airport"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Holiday"
            />
             <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Oneway"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer
                className="mb-8 overflow-y-scroll"
                style={{ maxHeight: "65vh", scrollbarWidth: "thin" }}
              >
                <Table>
                  <TableHeader className="capitalize text-center sticky top-0 z-10 text-sm">
                    <TableRow>
                      <TableCell>Sl.No.</TableCell>
                      {tab !== 1 && <TableCell>Days</TableCell>}
                      {tab === 1 && <TableCell>Hours</TableCell>}
                      <TableCell>Percentage</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHeader>
                  <CancellationPolicyTable
                    cancellationpolicy={dataTable}
                    perpage={itemsPerPage}
                    currentPage={currentPage}
                    tab={tab}
                    hideEdit={hideEdit}
                  />
                </Table>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no cancellation Policies." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default CancellationPolicy;
